export default "__VITE_ASSET__DKU4u5jK__"